import type { TextInputSize } from '@interstate/components/TextInput';
import { TextInput } from '@interstate/components/TextInput';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import type { KeyboardEventHandler } from 'react';
import React from 'react';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { useSellRateInputFocus } from './hooks/useSellRateInputFocus';

const SellRateInput = (props: {
    showLabelLink: boolean | undefined;
    size: TextInputSize;
    label: string;
    name: string;
    onChange: (e: InterstateOnChangeEvent<string>) => void;
    inputPrefix?: string;
    onBlur: (e: InterstateOnChangeEvent<string>) => void;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    hasError: boolean;
    errorMessage: string | undefined;
    placeholder: string;
    value: string;
    dataTestId: string;
    handleClick: () => void;
    readOnly?: boolean;
    disabled?: boolean;
}) => {
    const {
        showLabelLink,
        size,
        label,
        name,
        inputPrefix,
        onChange,
        onBlur,
        onKeyDown,
        hasError,
        errorMessage,
        placeholder,
        value,
        dataTestId,
        handleClick,
        readOnly,
        disabled
    } = props;

    const handleFocus = useSellRateInputFocus();

    return (
        <>
            {showLabelLink && (
                <label
                    className="base-deal-activity-control-custom-label"
                    data-testid={'rate-input-label'}
                    style={{
                        color: '#005BA8',
                        height: '17px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                    }}
                    onClick={handleClick}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleClick();
                        }
                    }}
                    tabIndex={0}
                    role="button"
                >
                    Rate
                    <ChevronRightIcon fontSize={10} />
                </label>
            )}
            <TextInput
                size={size}
                label={label}
                name={name}
                inputPrefix={inputPrefix}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={handleFocus}
                onKeyDown={onKeyDown}
                hasError={hasError}
                errorMessage={errorMessage}
                placeholder={placeholder}
                value={value}
                data-testid={dataTestId}
                displayLabel={!showLabelLink}
                readOnly={showLabelLink && readOnly}
                disabled={disabled}
            />
        </>
    );
};

export default SellRateInput;
